import type { DraftTask, Priority, Project, Task } from "./types";

export const MAX_TITLE = 180;
export const MAX_NOTES = 4000;
export const MAX_PROJECT_NAME = 80;
const FALLBACK_PROJECT_COLOR = "#8f7a5c";

export function nowIso(): string {
  return new Date().toISOString();
}

export function uid(): string {
  if (crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

export function cleanText(value: string, max: number): string {
  return value.replace(/\s+/g, " ").trim().slice(0, max);
}

export function cleanNotes(value: string): string {
  return value.trim().slice(0, MAX_NOTES);
}

export function isPriority(value: string): value is Priority {
  return value === "none" || value === "low" || value === "medium" || value === "high";
}

export function createTask(userId: string, draft: DraftTask, position: number): Task {
  const timestamp = nowIso();
  return {
    id: uid(),
    user_id: userId,
    title: cleanText(draft.title, MAX_TITLE),
    notes: cleanNotes(draft.notes),
    completed: false,
    priority: draft.priority,
    due_date: draft.due_date,
    project_id: draft.project_id,
    position,
    created_at: timestamp,
    updated_at: timestamp,
    deleted_at: null,
  };
}

export function createProject(userId: string, name: string, position: number): Project {
  const timestamp = nowIso();
  return {
    id: uid(),
    user_id: userId,
    name: cleanText(name, MAX_PROJECT_NAME),
    color: FALLBACK_PROJECT_COLOR,
    position,
    created_at: timestamp,
    updated_at: timestamp,
  };
}

export function cleanColor(value: string): string {
  return /^#[0-9a-f]{6}$/i.test(value) ? value : FALLBACK_PROJECT_COLOR;
}

export function isTextInput(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName.toLowerCase();
  return target.isContentEditable || tag === "input" || tag === "textarea" || tag === "select";
}

export function todayKey(): string {
  const date = new Date();
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date.toISOString().slice(0, 10);
}

export function isUpcoming(date: string | null): boolean {
  return Boolean(date && date > todayKey());
}
